// src/components/ui/UpdateBanner.tsx

import React from 'react';
import { RefreshCw } from 'lucide-react';

interface UpdateBannerProps {
  visible: boolean;
  onReload: () => void;
  appName?: string;
}

/**
 * Full-width banner pinned to the top of the viewport announcing that a
 * new version of the app is available. Purely presentational — the consuming
 * app wires `visible`/`onReload` to its own service worker registration
 * (e.g. useRegisterSW from virtual:pwa-register/react). Intentionally not
 * dismissible: it stays until the user reloads.
 */
const UpdateBanner: React.FC<UpdateBannerProps> = ({
  visible,
  onReload,
  appName = 'the app'
}) => {
  if (!visible) return null;

  return (
    <div className="fixed top-0 inset-x-0 z-50 bg-primary text-white px-4 py-2 flex items-center justify-between gap-4 text-sm shadow-lg print:hidden">
      <div className="flex items-center gap-2">
        <RefreshCw className="h-4 w-4 flex-shrink-0" />
        <span>
          A new version of <strong>{appName}</strong> is available.
        </span>
      </div>
      <button
        onClick={onReload}
        className="flex items-center gap-1.5 bg-white hover:bg-primary-light px-4 py-1.5 rounded font-medium text-primary text-sm transition-colors flex-shrink-0"
      >
        <RefreshCw className="h-3.5 w-3.5" />
        Reload Now
      </button>
    </div>
  );
};

export default UpdateBanner;
